"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
require("./Shimmer.scss");
const ShimmerComponent = ({ width, height, circle, customClass, widthRandomness, heightRandomness, isWhiteBackground = true }) => {
    let finalWidth = width;
    let finalHeight = height;
    if (widthRandomness) {
        const w = (0, isNumber_1.default)(width) ? width : parseFloat(width);
        const unit = width.toString().replace(/\d+/g, '');
        finalWidth = '' + (w - Math.random() * w * widthRandomness) + unit;
    }
    if (heightRandomness) {
        const h = (0, isNumber_1.default)(height) ? height : parseFloat(height);
        const unit = height.toString().replace(/\d+/g, '');
        finalHeight = '' + (h - Math.random() * h * heightRandomness) + unit;
    }
    const shimmerCN = (0, classnames_template_literals_1.default)(`
    inline-block
    animate
    ${!isWhiteBackground && 'base'}
    ${circle && 'rounded-full'}
    ${customClass && customClass}
  `);
    return (react_1.default.createElement("span", { className: shimmerCN, style: { height: finalHeight, width: finalWidth } }));
};
const Shimmer = ({ align, count, width, height, circle, customClass, widthRandomness, heightRandomness, isWhiteBackground }) => {
    const wrapperCN = (0, classnames_template_literals_1.default)(`
    flex
    ${align == 'vertical' ? 'flex-col' : ''}
    ${align == 'horizontal' ? 'flex-row' : ''}
  `);
    if (count && count > 0) {
        const element = [];
        const customClassCN = (0, classnames_template_literals_1.default)(`
      ${customClass && customClass}
      ${align == 'vertical' && 'mb-[8px]'}
      ${align == 'horizontal' && 'mr-[8px]'}
    `);
        for (let i = 0; i < count; i++) {
            element.push(react_1.default.createElement(ShimmerComponent, { width: width, height: height, circle: circle, widthRandomness: widthRandomness, heightRandomness: heightRandomness, isWhiteBackground: isWhiteBackground, customClass: customClassCN, key: i }));
        }
        return react_1.default.createElement("div", { className: wrapperCN }, element);
    }
    return (react_1.default.createElement(ShimmerComponent, { width: width, height: height, circle: circle, widthRandomness: widthRandomness, heightRandomness: heightRandomness, isWhiteBackground: isWhiteBackground, customClass: customClass }));
};
Shimmer.defaultProps = {
    width: '150px',
    height: '25px',
    animate: true,
    circle: false,
    count: 0,
    widthRandomness: 0,
    heightRandomness: 0,
    align: 'vertical'
};
exports.default = Shimmer;
